module.exports = __webpack_public_path__ + "static/media/27OCHA15.c437c2f2.jpg";